import React ,{useState, Fragment} from "react";
import {useDispatch, useSelector} from "react-redux";
import ARROW from "./../../../../../assets/images/up-blue.svg";
import CALL from "./../../../../../assets/images/call_icon.svg"
import Accordion from 'react-bootstrap/Accordion';
import LabOrderDetail from "./LabOrderDetail";
import LabOrderItemsList from "./LabOrderItemsList";
import LabOrderActions from "./LabOrderActions";
import LabOrderItemKeyValueMobile from "./children/LabOrderItemKeyValueMobile";
import PAYMENCOUNT from "./../../../../../assets/images/waitPayment.svg"

const LabOrderItemMobile = (props) => {
    console.log("props in mobil", props)
    const {order, activeTile} = props
  const {
    id,  
    customer_contact_name,
    jalali_created_at,
    customer_contact_phone,
    customer_description
  } = order;
  const [open, setOpen] = useState(false)
  const clickOnAccordion = () => {
    setOpen(!open)
  }
  const {
    lab_active_tile,
  } = useSelector((state) => state.dashboard);


  const renderItem = () => {
    if(lab_active_tile !== "waiting_for_payment") {
      return (
        <Accordion className="bg-white shadow-sm lab-order-item-holder lab-order-item-holder-mobile">
        <Accordion.Toggle  variant="link" eventKey={id}
          className="lab-order-item-mobile bg-white"
          onClick={() => clickOnAccordion()}
        >
                <div className='top-holder'>
                    <div className="date-and-time">
                        {jalali_created_at}
                    </div>
                    <div className="order-id">
                        #{id}
                    </div>
                </div>
                <div className={open ? 'customer-data-holder is-open' : 'customer-data-holder'}>
                    <div className='customer-name'>
                        {customer_contact_name}
                    </div>
                    <div className='customer-contact-data'>
                        <div className='customer-phone'>
                            {customer_contact_phone}
                            {open ? (<img src={CALL} width={14} />) : (<Fragment />)}
                        </div>
                    </div>
    
                </div>
                <div className="order-description-mobile">
                    <span>توضیحات سفارش :</span>
              <p> {customer_description ?? "-"}</p>
            </div>
          <div className="expand-btn">
            <img className={open ? '' : 'down-icon'} src={ARROW} alt="arrow" width={15} />
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={id}>
          <div className="lab-order-details bg-white row">
              <div className="col-lg-7 col-md-7 col-sm-12">
                  <LabOrderDetail order={order} />
                  <div className="lab-space" ><LabOrderItemsList order={order} /></div>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 lab-order-actions-holder">
                  <div className="key-value-details">
                    { order.meta_data !== null && ( <LabOrderItemKeyValueMobile {...order} />)}
                  </div>
                  <div className="lab-space" ><LabOrderActions order={order} /></div>
              </div>
          </div>
        </Accordion.Collapse>
      </Accordion>
      ) 
    } else {
        return (
          <div className="waiting-payment-lab-mobile">
            <img src={PAYMENCOUNT}></img>
            <div className="more-info-waiting-lab">
              <span>
              شما در انتظار پرداخت
              <span className="count">{activeTile.count}</span>
              کاربر هستید
              </span>
            </div>
          </div>
        )
      }
    }

  return (
    <div>{renderItem()}</div>
  );
};

export default LabOrderItemMobile;
